import { useAuth0 } from '@auth0/auth0-react'
import Loader from '@/components/atom/loader/loader'
import { useEffect } from 'react'

const Login = () => {
  const { loginWithRedirect, isAuthenticated, isLoading, error } = useAuth0()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect()
    }

    if (isAuthenticated) {
      window.location.href = '/app/home'
    }
  }, [isLoading, isAuthenticated, error, loginWithRedirect])
  return (
    <div data-testid='login-page' className='flex h-screen w-full'>
      <Loader />
    </div>
  )
}

export default Login
